import { Checkbox, ChoiceRow, FormBlock } from '@westhetics/ui'
import type { Audience } from '@/features/clinic-profile/api'
import { AUDIENCES, AUDIENCE_LABELS } from '@/features/clinic-profile/labels'

/**
 * Os públicos para quem a clínica emite documentos (RN-ADM-57). Só root define, na criação e no
 * painel; pacientes é o público de toda clínica e não sai da lista.
 */

const DESCRIPTIONS: Record<Audience, string> = {
  patient: 'O público de toda clínica: não sai da lista.',
  student: 'Alunos de curso.',
  employee: 'Funcionários e prestadores de serviço da clínica.',
  third_party: 'Parceiros, fornecedores e influenciadores.',
}

export function AudiencesBlock({
  value,
  onChange,
  error,
}: {
  value: Audience[]
  onChange: (audiences: Audience[]) => void
  error?: string
}) {
  function toggle(audience: Audience, checked: boolean) {
    const chosen = checked ? [...value, audience] : value.filter((item) => item !== audience)
    // Na ordem do contrato, sem repetição.
    onChange(AUDIENCES.filter((item) => item === 'patient' || chosen.includes(item)))
  }

  return (
    <FormBlock
      title="Documentos"
      note="Para quem a clínica emite documentos. Pacientes sempre; os outros, se contratou."
    >
      <div className="eyebrow" id="clinic-audiences-label">
        Públicos
      </div>
      <div
        role="group"
        aria-labelledby="clinic-audiences-label"
        className="tablet:grid-cols-2 mt-[6px] grid grid-cols-1 gap-2"
      >
        {AUDIENCES.map((audience) => (
          <ChoiceRow
            key={audience}
            control={
              <Checkbox
                checked={audience === 'patient' || value.includes(audience)}
                disabled={audience === 'patient'}
                onCheckedChange={(checked) => toggle(audience, checked === true)}
              />
            }
            description={DESCRIPTIONS[audience]}
          >
            {AUDIENCE_LABELS[audience]}
          </ChoiceRow>
        ))}
      </div>
      {error ? (
        <p
          role="alert"
          className="font-body text-eyebrow text-plum mt-[6px] leading-[1.5] font-light tracking-normal"
        >
          {error}
        </p>
      ) : null}
    </FormBlock>
  )
}
